export default function Registerbutton({ scrollToThisID = "registerForm" }) {
  const handleScroll = () => {
    const element = document.getElementById(scrollToThisID);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="flex justify-center items-center p-8 bg-black">
      <div className="relative flex items-center">
        {/* خطوط افقی محو شده */}
        <div className="absolute w-24 max-[600px]:w-20 h-px bg-gradient-to-r from-purple-600/0 to-[#7E42FF] right-full mr-[14px]"></div>
        <div className="absolute w-24 max-[600px]:w-20 h-px bg-gradient-to-l from-purple-600/0 to-[#7E42FF] left-full ml-[14px]"></div>

        {/* دکمه با سه حاشیه */}
        <button
          onClick={handleScroll}
          className="relative px-12 max-[600px]:px-7 max-[600px]:py-2 py-4 text-[#7E42FF] text-xl font-medium"
        >
          <span className="absolute -inset-[14px] rounded-full border-[0.2px] border-purple-600/30 border-[#7E42FF]"></span>
          <span className="absolute -inset-[7px] rounded-full border-2 border-purple-600/80 border-[#7E42FF]"></span>
          <span className="absolute inset-0 rounded-full  border-[#7E42FF] border-[3px]"></span>

          <span className="relative font-bold max-[600px]:text-sm" dir="rtl">
            ثبــت نــام در دوره
          </span>
        </button>
      </div>
    </div>
  );
}
